.link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: var(--target-min);
  padding: 0 6px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: transparent;
  color: var(--accent);
  font-size: var(--t-min);
  font-weight: 600;
  cursor: pointer;
}

.link:hover {
  background: var(--accent-w);
  color: var(--accent-h);
}

.link:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.text {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-body);
  line-height: 1.5;
}
